import styled from 'styled-components';

interface WithdrawalUnfinishedTransactionStyledProps {
    show: boolean,
}

export const WithdrawalUnfinishedTransactionStyled = styled.div<WithdrawalUnfinishedTransactionStyledProps>`
    margin-bottom: 24px;
`;

interface WithdrawalUnfinishedTransactionRowStyledProps {
    stacked?: boolean,
}

export const WithdrawalUnfinishedTransactionRowStyled = styled.div<WithdrawalUnfinishedTransactionRowStyledProps>`
    border-radius: 16px;
    margin-bottom: 8px;
    background: var(--color-surface-primary);

    &:last-child {
        margin-bottom: 0;
    }
    
    ${({stacked}) => stacked && `
        box-shadow: 0 12px 0px -4px var(--color-neutral-10);
    `};
`;

export const WithdrawalUnfinishedTransactionItemStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--color-white-95);

    padding: 12px 16px 16px;
`;
